export const isKeyboardOrClick = key => key === 'Enter' || key === ' ' || typeof key === 'undefined'

export const onMouseDown = event => event.preventDefault()
